module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "number-input"
  }, [_c('div', {
    staticClass: "input-button decrease",
    on: {
      "click": _vm.decrease
    }
  }, [_vm._v("−")]), _c('input', {
    attrs: {
      "type": "number",
      "name": _vm.model,
      "min": _vm.min,
      "max": _vm.max
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.updateValue
    }
  }), _c('div', {
    staticClass: "input-button increase",
    on: {
      "click": _vm.increase
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.model
    }
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4414a7f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputNumber.vue
// module id = 32
// module chunks = 0